import { ErrorMessageContents } from '../../helpers/hub'
import { UserEditorData } from './types'

export const saveUserEditorData = (userEditorData: UserEditorData) =>
  ({
    type: 'userEditorData.saveUserEditorData',
    payload: userEditorData
  } as const)
type UserEditorDataSaveAction = ReturnType<typeof saveUserEditorData>

export const saveUserEditorDataSuccess = (errors: any) =>
  ({
    type: 'userEditorData.saveUserEditorDataSuccess',
    payload: errors
  } as const)
export type UserEditorDataSaveSuccessAction = ReturnType<
  typeof saveUserEditorDataSuccess
>

export const saveUserEditorDataFailure = (error: ErrorMessageContents) =>
  ({
    type: 'userEditorData.saveUserEditorDataFailure',
    payload: error,
    error: true
  } as const)
export type UserEditorDataSaveFailureAction = ReturnType<
  typeof saveUserEditorDataFailure
>

export const fetchUserEditorData = (userId: number) =>
  ({ type: 'userEditorData.fetchUserEditorData', payload: userId } as const)
type UserEditorDataFetchAction = ReturnType<typeof fetchUserEditorData>

export const addUserEditorData = (error: any) =>
  ({ type: 'userEditorData.addUserEditorData', payload: error } as const)
export type AddUserEditorDataAction = ReturnType<typeof addUserEditorData>

export type UserEditorDataAction =
  | UserEditorDataSaveAction
  | UserEditorDataSaveSuccessAction
  | UserEditorDataSaveFailureAction
  | UserEditorDataFetchAction
  | AddUserEditorDataAction
